<template>
  <div class="h-dialogContainer">
    <div class="h-borderBox" style="height:320px">
      <div class="h-dialog-borderBox-topIcon">{{$t('MCS.groupNum')}}  {{userNum}}
        <div class="h-toolbarBg dialog-icon-style">
          <ejs-toolbar class="dialog-icon-style">
            <div class="dialog-icon-style" >
              <div>
                <button :title='$t("MCS.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn dialog-icon-style" data-ripple="true" tabindex="-1" @click='delGroupMember'>
                  <span class="e-btn-icon icon hero-icon hero-icon-remove e-icons"></span>
                </button>
              </div>
            </div>
          </ejs-toolbar>
        </div>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :dataSource="data" height='169px' :allowReordering='true' :allowResizing='true' :rowSelected='lineClick' :rowDeselected='lineClick'>
          <e-columns>
            <e-column field='mcid' headerText='MC-ID' width='20%' textAlign='Center'></e-column>
            <e-column field='mcname' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userAlias")' width='20%' textAlign='Center'></e-column>
            <e-column field='userpriority' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userPriority")' width='20%' textAlign='Center'></e-column>
            <e-column field='participantType' clipMode='EllipsisWithTooltip' :valueAccessor='participantTypeFormatter' :headerText='$t("MCS.participantType")' width='150' textAlign='Center'></e-column>
            <e-column field='user_privilege' clipMode='EllipsisWithTooltip' :valueAccessor='userPrivilegeFormatter' :headerText='$t("MCS.userPrivilege")' width='20%' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
      </div>
    </div>
    <br/>
    <div class="h-borderBox height-260">
      <div class="h-borderBox-content" style="overflow: hidden">
        <div class="h-dialog-borderBox-topIcon">
          <div class="h-toolbarBg dialog-icon-style">
            <ejs-toolbar class="dialog-icon-style">
              <div class="dialog-icon-style" >
                <div>
                  <button :title='$t("MCS.mod")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn dialog-icon-style" data-ripple="true" tabindex="-1" @click='modGroupMember'>
                    <span class="e-btn-icon icon hero-icon hero-icon-save e-icons"></span>
                  </button>
                </div>
              </div>
            </ejs-toolbar>
          </div>
        </div>
        <div class="h-borderBox-content" style="overflow: hidden">
          <div class="col-sm-6 h-col-inputBox">
            <span>MC-ID:</span>
            <ejs-textbox :cssClass='clsInput' v-model='textObj.mcid.val' :readonly='textObj.mcid.readonly'/>
          </div>
          <div class="col-sm-6 h-col-inputBox">
            <span>{{$t('MCS.userAlias')}}:</span>
            <ejs-textbox :cssClass='clsInput' v-model='textObj.userAlias.val' :readonly='textObj.userAlias.readonly'/>
          </div>
          <div class="col-sm-6 h-col-inputBox">
            <span>{{$t('MCS.userPriority')}}:</span>
            <ejs-dropdownlist :fields='fields' :dataSource='optionsUserPriority' v-model='textObj.userPriority.val' :readonly='textObj.userPriority.readonly'/>
          </div>
          <div class="col-sm-6 h-col-inputBox">
            <span>{{$t('MCS.userPrivilege')}}:</span>
            <ejs-dropdownlist :fields='fields' :dataSource='optionsUserPrivilege' v-model='textObj.userPrivilege.val' :readonly='textObj.userPrivilege.readonly'/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonJS from '../../common';

export default {
  name: 'QryGroupMemberDialog',
  mixins: [commonJS],
  props: [
    'neid'
  ],
  data() {
    return {
      textObj: {
        mcid: {
          val: '',
          readonly: true
        },
        userAlias: {
          val: '',
          readonly: true
        },
        userPriority: {
          val: 1,
          readonly: true
        },
        userPrivilege: {
          val: 0,
          readonly: true
        },
      },
      data: '',
      userNum: '',
      clsInput: 'h-subscriber-input',
      page: {
        pageNo: '1',
        pageSize: '15',
        totalCount: '0',
        pageCount: '0',
      },
      delFlag: false
    };
  },
  methods: {
    getGridData(userNum = this.userNum) {
      const $this = this;
      this.userNum = userNum;
      const params = {
        info: {
          neid: this.neid,
          msgid: this.msg.qryGroupMember
        },
        vo: {
          flag: 0,
          groupid: userNum
        },
        page: {
          pageNo: $this.$refs.pager.ej2Instances.currentPage,
          pageSize: this.page.pageSize
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        const res = response.data.resultVal;
        $this.data = res.result;
        $this.page.totalCount = res.countrsp;
      });
    },
    delGroupMember() {
      const $this = this;
      if ($this.$refs.grid.getSelectedRecords().length === 0) {
        $this.$toast('warning', $this.$t('Common.tips.noSelect'))
        return;
      }
      $this.$layer.confirm({
        msg: $this.$t('MCS.deleteConfirm'),
        btn1: {
          msg: $this.$t('MCS.confirm'),
          func: () => {
            const vo = {
              groupid: $this.userNum,
              groupmemberid: $this.$refs.grid.getSelectedRecords()[0].groupmemberid,
              flag: 0
            };
            const params = {
              vo: vo,
              info: {
                msgid: $this.msg.delGroupMember,
                neid: $this.neid
              },
              log: {
                module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
                execFunName: 'subscriber.delroupMember',
                exectype: 1,
                execData: [{ groupid: vo.groupid, userNum: $this.$refs.grid.getSelectedRecords()[0].mcid }]
              }
            };
            this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
              this.getGridData();
              this.$toast('success');
              this.delFlag = true;
              this.textObj = {
                mcid: {
                  val: '',
                  readonly: true
                },
                userAlias: {
                  val: '',
                  readonly: true
                },
                userPriority: {
                  val: 1,
                  readonly: true
                },
                userPrivilege: {
                  val: 0,
                  readonly: true
                },
              };
            });
          }
        },
        btn2: {
          msg: this.$t('MCS.cancle'),
        }
      });
    },
    modGroupMember() {
      if (this.$refs.grid.getSelectedRecords().length === 0) {
        this.$toast('warning', this.$t('Common.tips.noSelect'));
        return;
      }
      const vo = this.$refs.grid.getSelectedRecords()[0];
      vo.mcname = this.textObj.userAlias.val;
      vo.user_privilege = this.textObj.userPrivilege.val;
      vo.userpriority = this.textObj.userPriority.val;
      const params = {
        info: {
          neid: this.neid,
          msgid: this.msg.modGroupMember
        },
        vo: vo,
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
          execFunName: 'subscriber.modGroupMember',
          exectype: 1,
          execData: [{ groupNum: vo.groupid, userNum: vo.mcid }]
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        this.getGridData();
        this.$toast('success');
      });
    },
    lineClick() {
      if (this.$refs.grid.getSelectedRecords().length === 0) {
        this.textObj = {
          mcid: {
            val: '',
            readonly: true
          },
          userAlias: {
            val: '',
            readonly: true
          },
          userPriority: {
            val: 1,
            readonly: true
          },
          userPrivilege: {
            val: 0,
            readonly: true
          },
        };
      } else {
        const record = this.$refs.grid.getSelectedRecords()[0];
        if (this.delFlag === true) {
          this.delFlag = false;
          return;
        }
        this.textObj = {
          mcid: {
            val: record.mcid,
            readonly: true
          },
          userAlias: {
            val: record.mcname,
            readonly: true
          },
          userPriority: {
            val: record.userpriority,
            readonly: false
          },
          userPrivilege: {
            val: record.user_privilege,
            readonly: record.participantType === 4 ? false : true
          },
        };
      }
    }
  },

};
</script>

<style scoped>

</style>
